import React from 'react';
import {Button, Space} from 'antd';

import {faCopyright} from "@fortawesome/free-regular-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {Flex} from "../components/styled/Flex";
import moment from 'moment';
import {Text} from "../components/styled/Text";
import logocnr from './logo-cnr.svg';
import logodsb from './logo-dsb.svg';
import logoiit from './logo-iit.svg';
import logoisti from './logo-isti.svg';
import {XLMediaQuery} from "../components/mediaquery/XLMediaQuery";
import {LMediaQuery} from "../components/mediaquery/LMediaQuery";
import {MMediaQuery} from "../components/mediaquery/MMediaQuery";
import {XSMediaQuery} from "../components/mediaquery/XSMediaQuery";
import {SMediaQuery} from "../components/mediaquery/SMediaQuery";

import {ConfigContext} from "../context/ConfigurationContext";
import {Link} from "react-router-dom";
import {useKeycloak} from "@react-keycloak/web";

interface FooterInterface {}

const IIT_URL = "https://www.iit.cnr.it";
const ISTI_URL = "https://www.isti.cnr.it";
const CNR_URL = "https://www.cnr.it";
const DSB_URL = "http://dsb.cnr.it";

const Footer: React.FC<FooterInterface> = (props) => {
    const year = moment().year();
    const conf = React.useContext(ConfigContext);
    const {keycloak, initialized} = useKeycloak();

    const isAuthenticated = (initialized && keycloak.authenticated);


    const footerVerySmall = () => {
        return (

            <Flex direction={'column'}
                  style={{

                      backgroundColor: 'white',
                      borderTop: '1px solid #e8e8e8',
                  }}
            >

                <Flex direction={'row'}>

                    <Text marginRight={'20px'}><FontAwesomeIcon icon={faCopyright} style={{marginRight: '5px'}}/><span>{year}</span></Text>
                    <Text marginRight={'20px'} fontSize={'1rem'} fontWeight={'700'}>{'SerGenCovid-19'}</Text>
                </Flex>
                <Flex direction={'row'}>


                    <Text  marginTop={'5px'} marginLeft={'10px'}>
                        <a target="_blank" rel="noopener noreferrer"  href={CNR_URL}><img height={'25px'} width={'auto'} alt={"CNR"} src={logocnr}/></a>
                    </Text>
                    <Text   marginTop={'5px'} marginLeft={'10px'}>
                        <a target="_blank" rel="noopener noreferrer"  href={DSB_URL}><img height={'25px'} width={'auto'} alt={"DSB"} src={logodsb}/></a>
                    </Text>

                    <Text  marginTop={'5px'} marginLeft={'10px'}>
                        <a target="_blank" rel="noopener noreferrer" href={IIT_URL}><img height={'25px'} width={'auto'}  alt={"IIT"} src={logoiit}/></a>
                    </Text>
                    <Text  marginTop={'5px'} marginLeft={'10px'}>
                        <a target="_blank" rel="noopener noreferrer"  href={ISTI_URL}><img height={'25px'} width={'auto'}  alt={"ISTI"} src={logoisti}/></a>
                    </Text>
                </Flex>
                <Flex direction={'row'}>

                    <Button type={'link'}>
                        <a style={{color: 'green', fontWeight: 700}} href={`${conf['contactsLink']}`}>
                            Contatti
                        </a>
                    </Button>

                    <Button type={'link'}>
                        <Link style={{color: 'green', fontWeight: 700}} to={'/gip/informativa'}>
                            Informativa Progetto
                        </Link>
                    </Button>
                    {
                        isAuthenticated &&
                        <Button type={'link'}>
                            <a style={{color: 'green', fontWeight: 700}} target="_blank" rel="noopener noreferrer"
                               href={`${conf['modelloRecessoLink']}`}>
                                Modello Diritto di Recesso
                            </a>

                        </Button>
                    }
                </Flex>
            </Flex>
        )
    };




    const footerSmall = () => {
        return (
        <Flex direction={'row'} justify={'space-around'}
              style={{

                  backgroundColor: 'white',
                  borderTop: '1px solid #e8e8e8',
              }}
        >
            <Flex direction={'column'}>
                <Text marginRight={'20px'}><FontAwesomeIcon icon={faCopyright} style={{marginRight: '5px'}}/><span>{year}</span></Text>
                <Text marginLeft={'0px'} fontSize={'1rem'} fontWeight={'700'}>{'SerGenCovid-19'}</Text>
            </Flex>
            <Flex direction={'column'} justify={'space-around'} style={{marginTop: '20px', marginBottom: '20px'}}>
                <Text marginBottom={'20px'}>
                    <a target="_blank" rel="noopener noreferrer" href={CNR_URL}><img height={'25px'} width={'auto'}  alt={"CNR"}  src={logocnr}/></a>
                </Text>
                <Text  >
                    <a target="_blank" rel="noopener noreferrer" href={DSB_URL}><img height={'25px'} width={'auto'}  alt={"DSB"}  src={logodsb}/></a>
                </Text>
            </Flex>

            <Flex direction={'column'} style={{marginTop: '20px', marginBottom: '20px'}}>
                <Text  marginBottom={'20px'}>
                    <a target="_blank" rel="noopener noreferrer" href={IIT_URL}><img height={'25px'} width={'auto'}  alt={"IIT"}  src={logoiit}/></a>
                </Text>
                <Text>
                    <a target="_blank" rel="noopener noreferrer" href={ISTI_URL}><img height={'25px'} width={'auto'}  alt={"ISTI"} src={logoisti}/></a>
                </Text>
            </Flex>

            <Flex direction={'column'} style={{marginTop: '20px', marginBottom: '20px'}}>

                <Button type={'link'}>
                    <a style={{color: 'green', fontWeight: 700}} href={`${conf['contactsLink']}`}>
                        Contatti
                    </a>
                </Button>

                <Button type={'link'}>
                    <Link style={{color: 'green', fontWeight: 700}} to={'/gip/informativa'}>
                        Informativa Progetto
                    </Link>
                </Button>
                {
                    isAuthenticated &&
                    <Button type={'link'}>
                        <a style={{color: 'green', fontWeight: 700}} target="_blank" rel="noopener noreferrer"
                           href={`${conf['modelloRecessoLink']}`}>
                            Modello Diritto di Recesso
                        </a>

                    </Button>
                }
            </Flex>
        </Flex>
        )
    };

    const footerBig = () => {
        return (
        <Flex direction={'row'}
              style={{
                  height: '50px',
                  backgroundColor: 'white',
                  borderTop: '1px solid #e8e8e8',
              }}
        >
            <Space>
            <Text ><FontAwesomeIcon icon={faCopyright} style={{marginRight: '5px'}}/><span>{year}</span></Text>
            <Text fontSize={'1rem'} fontWeight={'700'}>{'SerGenCovid-19'}</Text>
            <Text marginLeft={'20px'}>
                <a target="_blank" rel="noopener noreferrer" href={CNR_URL}><img height={'35px'} width={'auto'}  alt={"CNR"} src={logocnr}/></a>
            </Text>
            <Text marginLeft={'20px'}>
                <a target="_blank" rel="noopener noreferrer" href={DSB_URL}><img height={'35px'} width={'auto'}  alt={"DSB"} src={logodsb}/></a>
            </Text>
            <Text marginLeft={'20px'} >
                <a target="_blank" rel="noopener noreferrer" href={IIT_URL}><img height={'35px'} width={'auto'}  alt={"IIT"} src={logoiit}/></a>
            </Text>
            <Text marginLeft={'20px'} marginRight={'30px'}>
                <a target="_blank" rel="noopener noreferrer" href={ISTI_URL}><img height={'35px'} width={'auto'}  alt={"ISTI"} src={logoisti}/></a>
            </Text>

                <Button type={'link'}>
                    <a style={{color: 'green', fontWeight: 700}} href={`${conf['contactsLink']}`}>
                        Contatti
                    </a>
                </Button>

                <Button type={'link'}>
                    <Link style={{color: 'green', fontWeight: 700}} to={'/gip/informativa'}>
                        Informativa Progetto
                    </Link>
                </Button>
                {
                    isAuthenticated &&
                    <Button type={'link'}>
                        <a style={{color: 'green', fontWeight: 700}} target="_blank" rel="noopener noreferrer"
                           href={`${conf['modelloRecessoLink']}`}>
                            Modello Diritto di Recesso
                        </a>

                    </Button>
                }
            </Space>
        </Flex>
        )
    };


    return (
        <footer style={{width: '100%'}} className="noprint">
            <XLMediaQuery>
                {footerBig()}
            </XLMediaQuery>
            <LMediaQuery>
                {footerBig()}
            </LMediaQuery>
            <MMediaQuery>
                {footerSmall()}
            </MMediaQuery>
            <XSMediaQuery>
                {footerSmall()}
            </XSMediaQuery>
            <SMediaQuery>
                {footerVerySmall()}
            </SMediaQuery>
        </footer>
    )
};

export default Footer;

